<template>
  <div class="vh100">
    <div class="add-add" @click="handleAddAddress">
      <i class="icon icon-add-add"></i>
      新增收货地址
    </div>
    <div class="add-list">
      <div class="add-item" v-for="(item,index) in addList" :key="index">
        <div class="add-cont" @click="select_add(item.id)">
          <div class="select-box" v-if="from_page =='order_pay_detail'">
            <i class="icon icon-check" :class="{'icon-checked':cid==item.id}"></i>
          </div>
          <div class="add-item-cont">
            <div class="add-peo font-85">
              <p>{{item.zname}}</p>
              <p>{{item.mobile_txt}}</p>
            </div>
            <p class="add-rel">{{item.address}}</p>
          </div>

        </div>
        <div class="add-edit" @click="handleEdit(item.id)">
          编辑
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import http from "../../request/http";

    export default {
        name: "address_list",
      data(){
          return {
            addList:[],
            cid:'',
            from_page:''
          }
      },
      methods:{
        addressList(){
          http.post('/api/wap/user/consigneelist').then(res=>{
            res.data.forEach(v => {
              v.mobile_txt = '';
              if(v.mobile){
                v.mobile_txt = v.mobile.slice(0,3)+'****'+v.mobile.slice(-4)
              }
            })
            this.addList = res.data;
          })
        },
        handleEdit(id){
          this.$router.push({
            name:'address_edit',
            query:{...this.$route.query,...{id:id}}
          })
        },
        select_add(cid){
          if(this.$route.query.from == 'order_pay_detail'){
            this.$router.replace({
              name:'order_pay_detail',
              query:{
                orderid:this.$route.query.orderid,
                cid:cid
              }
            })
          }
        },
        handleAddAddress(){
          let querys = this.$route.query;
          querys.id = '';
          this.$router.push({
            name:'address_edit',
            query:querys
          })
        }
      },
      mounted() {
          this.addressList();
          this.cid = this.$route.query.cid;
      },
      created(){
        if(this.$route.query.from){
          this.from_page = this.$route.query.from
        }
      }
    }
</script>

<style scoped>
  .vh100{
    height: 100vh;
    background: #fafafa;
    padding-top: 0.4rem;
  }
  .icon-check{
    width: 0.7rem;
    height: 0.7rem;
  }
  .add-list{
    width: 100%;
    height: auto;
    background: #fff;
  }
  .add-item{
    width: 100%;
    min-height: 4.8rem;
    border-bottom: 0.05rem solid rgba(245, 245, 245, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:1rem;
  }
  .add-cont{
    width: 80%;
    display: flex;
    justify-content: start;
  }
  .add-peo{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9rem;
    width: 100%;
  }
  .add-item-cont{
    width: 100%;
  }
  .add-rel{
    font-size: 0.7rem;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 0.4rem;
  }
  .add-edit{
    height: 100%;
    border-left: 0.05rem solid rgba(0, 0, 0, 0.09);
    width: 15%;
    line-height: 2.75rem;
    text-align: right;
    color: #1890FF;
    font-size: 0.7rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/address/address_list.vue